import React, { useEffect, useRef, useState } from 'react';
import styles from './MenuHeroSection.module.css';
import centerPattern from '../../assets/pattern.png';

const MenuHeroSection = () => {
  const [visible1, setVisible1] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const section1Ref = useRef(null);
  const section2Ref = useRef(null);

  const menuLeft = [
    { name: "Miso Black Cod", price: "₹2700", desc: "Grilled black cod with miso and black garlic sauce" },
    { name: "Hamachi Sashimi", price: "₹2375", desc: "Fresh hamachi slices" },
    { name: "New Zealand Lamb Chops", price: "₹2250", desc: "Lamb rack, confit potato disc, asparagus, rosemary pepper jus" },
    { name: "Salmon Aburi", price: "₹1465", desc: "Salmon and avocado roll" },
  ];

  const menuRight = [
    { name: "Peruvian Style Burrata", price: "₹985", desc: "Pomelo, grapefruit, edible flowers, arugula, balsamic pearls & basil pesto" },
    { name: "Truffle Prawn, Purple Shiso Bread", price: "₹1005", desc: "Pretzel, parmesan & chilli oil" },
    { name: "Cheese Wheel Linguine", price: "₹1660", desc: "Mascarpone, truffle cream, al tartufata" },
    { name: "Dynamite Prawns", price: "₹985", desc: "Tempura prawns, spicy mayo, sesame, chives" },
  ];

  useEffect(() => {
    const observerOptions = { threshold: 0.2 };

    const observer1 = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible1(true);
    }, observerOptions);

    const observer2 = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible2(true);
    }, observerOptions);

    if (section1Ref.current) observer1.observe(section1Ref.current);
    if (section2Ref.current) observer2.observe(section2Ref.current);

    return () => {
      observer1.disconnect();
      observer2.disconnect();
    };
  }, []);

  return (
    <div className={styles.wrapper}>
      {/* 1. Top Hero Image */}
      <div className={styles.hero}>
        <img src={'https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/Website%20Images/LAH-06837%201%20(1)%20(2).png'} alt="Food close up" />
      </div>

      {/* 2. Menu Section */}
      <section
        ref={section1Ref}
        className={`${styles.menuSection} ${visible1 ? styles.show : ""}`}
      >
        <div className={styles.container}>
          <div className={styles.menuHeader}>
            <h1 className={styles.animateFade}>Our Special Selection</h1>
            <p className={`${styles.animateFade} ${styles.delay1}`}>A selection of our chef's finest cuts</p>
          </div>

          <div className={styles.menuGrid}>
            <div className={styles.menuCol}>
              <h3>From the Sea</h3>
              {menuLeft.map((item, i) => (
                <div key={i} className={styles.menuItem} style={{ transitionDelay: `${(i + 3) * 100}ms` }}>
                  <div className={styles.itemHeader}>
                    <span className={styles.itemName}>{item.name}</span>
                    <span className={styles.itemPrice}>{item.price}</span>
                  </div>
                  <p className={styles.itemDesc}>{item.desc}</p>
                </div>
              ))}
            </div>

            <div className={`${styles.patternCol} ${styles.animateFade} ${styles.delay2}`}>
              <img src={centerPattern} alt="Decorative pattern" />
            </div>

            <div className={styles.menuCol}>
              <h3>Chef's Signatures</h3>
              {menuRight.map((item, i) => (
                <div key={i} className={styles.menuItem} style={{ transitionDelay: `${(i + 3) * 100}ms` }}>
                  <div className={styles.itemHeader}>
                    <span className={styles.itemName}>{item.name}</span>
                    <span className={styles.itemPrice}>{item.price}</span>
                  </div>
                  <p className={styles.itemDesc}>{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 3. Catering Section */}
      <section
        ref={section2Ref}
        className={`${styles.cateringSection} ${visible2 ? styles.show : ""}`}
      >
        <div className={styles.container}>
          <div className={styles.cateringGrid}>
            <div className={styles.cateringContent}>
              <h2 className={styles.animateFade}>Flavor fusion <br /> catering</h2>
              <p className={`${styles.animateFade} ${styles.delay1}`}>
                An exploration of flavours across cuisines, curated into a cohesive dining experience designed to offer variety without losing harmony. With a touch of artisanal execution, each element is thoughtfully composed to elevate special moments and create a sense of occasion.
              </p>
              <a href="#learn" className={`${styles.learnMore} ${styles.animateFade} ${styles.delay2}`}>
                Learn more <span className={styles.arrow}>↘</span>
              </a>
            </div>
            <div className={`${styles.cateringImage} ${styles.animateFade}`}>
              <img src={'https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/Website%20Images/this%20week.png'} alt="Catering display" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MenuHeroSection;